import React from "react";

const AwsUseCase = () => {
  return (
    <div className="about_area aws-challenge">
      <div className="container">
        <div className="row">
         <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-20 text-left">
            <p>To strengthen its mid-market foothold across India, ANZ, and ASEAN, a global cloud provider engaged ProPlus Data to overcome stagnating outreach and fragmented buyer intent. In a landscape defined by legacy dependencies and varied cloud maturity, the partnership enabled intelligence-led targeting at scale, driving 2X engagement and achieving 6-month pipeline goals in half the time.
</p>
              <div className="section_main_title">
                <h3>Challenge</h3>
              
              </div>
             
              
            </div>
            <div className="singel_about_left text-left">
              
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                 
                  <p>
                  A global cloud leader sought to boost mid-market traction across India, ANZ, and ASEAN. Despite growing cloud adoption, the target landscape was complex:

                  </p>
                </div>
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 
                  <p>
                  ● 3 geographies with varied cloud maturity <br/> ● Legacy tech lock-ins hampering migrations <br/> ● Lack of real-time buyer signals <br/> ● Low conversion from traditional outreach

                  </p>
                </div>
              </div>
             
               <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                 
                  <p>
                  The company needed more than raw data, it required precision targeting and market-specific intelligence to spark real buyer conversations.

                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            {/* <div className="section_title text_left mb-40 mt-3 text-left">
           
              <div className="section_main_title">
                <h2>ProPlus Data</h2>
              
              </div>
             
              
            </div> */}
            <div className="singel_about_left mb-30 text-left">
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                 
                </div>
                <div className="singel-about-content">
                  
                  <p>
                 ● Industry: Cloud Technology <br/>  ● Regions: India, ANZ, ASEAN <br/>● Objective: Accelerate qualified lead generation and conversion within 6 months <br/>● Result: Target achieved in 3 months, 2X engagement rate, 3X faster pipeline activation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwsUseCase;
